import React from "react";

function ErrorField() {
    return (
        <strong className="invalid-feedback">Required Field</strong>)
};
export default ErrorField;